<template>
  <section class="forwho" ref="root">
    <div class="forwho__inner" :class="{ 'forwho__inner_visible': inView }">
      <h2 class="forwho__headline">Для кого</h2>
      <p class="forwho__lead">Наши картины выбирают:</p>
      <ul class="forwho__list">
        <li class="forwho__item" v-for="(item, i) in items" :key="item.text" :style="{ transitionDelay: `${0.06 + i * 0.08}s` }">
          <span class="forwho__icon" v-html="item.icon" aria-hidden="true" />
          <span class="forwho__item-text">{{ item.text }}</span>
        </li>
      </ul>
      <p class="forwho__outro">
        Если ты веришь, что мышление формирует реальность —<br />
        <strong>ты по адресу.</strong>
      </p>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'HomeForWho',
  setup() {
    const root = ref(null)
    const inView = ref(false)
    let observer = null

    const items = [
      {
        text: 'Предприниматели и фрилансеры',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>`
      },
      {
        text: 'Те, кто растёт финансово',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>`
      },
      {
        text: 'Люди, которые ценят стиль и смысл',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>`
      },
      {
        text: 'Те, кто хочет окружать себя правильными символами',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15 9 22 9 17 14 19 21 12 17 5 21 7 14 2 9 9 9"/></svg>`
      },
      {
        text: 'Те, кто устал дарить банальные подарки',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/></svg>`
      }
    ]

    onMounted(() => {
      observer = new IntersectionObserver(
        ([e]) => { if (e.isIntersecting) inView.value = true },
        { threshold: 0.15, rootMargin: '0px 0px -80px 0px' }
      )
      if (root.value) observer.observe(root.value)
    })
    onUnmounted(() => observer?.disconnect())

    return { root, inView, items }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/_variables.scss";

$fw-duration: 0.6s;
$fw-ease: cubic-bezier(0.22, 1, 0.36, 1);

.forwho {
  position: relative;
  padding: 100px $gap 100px;
  background: $color-bg-alt;
  color: $color-primary-inverse;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background-image:
      radial-gradient(ellipse 70% 60% at 80% 20%, rgba(255, 255, 255, 0.04) 0%, transparent 45%),
      radial-gradient(ellipse 50% 40% at 20% 80%, rgba(255, 255, 255, 0.03) 0%, transparent 45%),
      url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='%23ffffff' stroke-opacity='0.04' stroke-width='0.5'%3E%3Cpath d='M0 30h60M30 0v60'/%3E%3C/g%3E%3C/svg%3E");
  }

  @media (max-width: $breakpoint-mobile) {
    padding: 64px $gap 72px;
  }

  &__inner {
    position: relative;
    z-index: 1;
    max-width: $container-max;
    margin: 0 auto;

    &_visible .forwho__headline { opacity: 1; transform: translateY(0); }
    &_visible .forwho__lead { opacity: 1; transform: translateY(0); }
    &_visible .forwho__item { opacity: 1; transform: translateY(0); }
    &_visible .forwho__outro { opacity: 1; transform: translateY(0); }
  }

  &__headline {
    font-size: clamp(14px, 1.5vw, 16px);
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    opacity: 0.6;
    margin: 0 0 20px;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity $fw-duration $fw-ease, transform $fw-duration $fw-ease;
  }

  &__lead {
    font-size: clamp(24px, 3.5vw, 36px);
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: -0.02em;
    margin: 0 0 36px;
    opacity: 0;
    transform: translateY(24px);
    transition: opacity $fw-duration $fw-ease 0.05s, transform $fw-duration $fw-ease 0.05s;

    @media (max-width: $breakpoint-mobile) {
      margin-bottom: 28px;
    }
  }

  &__list {
    list-style: none;
    margin: 0 0 48px;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 20px;

    @media (max-width: $breakpoint-mobile) {
      grid-template-columns: 1fr;
      margin-bottom: 40px;
      gap: 16px;
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
    padding: 28px 20px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity $fw-duration $fw-ease, transform $fw-duration $fw-ease,
      border-color 0.2s, background 0.2s, box-shadow 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(255, 255, 255, 0.2);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    }
  }

  &__icon {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    background: rgba(255, 255, 255, 0.12);
    color: $color-primary-inverse;
    border-radius: 12px;

    :deep(svg) {
      width: 26px;
      height: 26px;
    }
  }

  &__item-text {
    font-size: clamp(15px, 1.5vw, 17px);
    font-weight: 600;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.95);
  }

  &__outro {
    font-size: clamp(18px, 2vw, 22px);
    line-height: 1.5;
    margin: 0;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity $fw-duration $fw-ease 0.25s, transform $fw-duration $fw-ease 0.25s;

    strong {
      font-weight: 800;
    }
  }
}

.forwho__inner_visible .forwho__headline { opacity: 0.6 !important; }
.forwho__inner_visible .forwho__outro { opacity: 0.9 !important; }
</style>
